import React, { useContext, useState } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import SimpleTarhs from './SimpleTarhs';
import SimpleContext from './../../context/SimpleContext';
import './SimpleProduct.css'
import config from './../../../services//config.json';
import { useHistory } from 'react-router-dom';

const SimplePro = ({
    category,
    slug,
    name,
    price,
    Discount_Price,
    user_price,
    unit,
    numSale,
    ULImg,
    min,
    max,
    numUnit,
    unique_id,
    goodsRef,
    Role,
    sahmie_bandi
}) => {

    const context = useContext(SimpleContext);
    const [clicked, setClicked] = useState(0);
    const [DialogSabtInSabad, setDialogSabtInSabad] = useState(false); 
    const history = useHistory()
    const [RoleCheck, setRoleCheck] = useState(false);
    const [DeleteDialog, setDeleteDialog] = useState(false);


    const handleShowSingleProduct = (catname) => {
      let Single = [...context.products]
      const SinglePrd = Single.filter(pr => pr.category.split("/")[0] === catname) 
      context.setSinglePrdCategory(SinglePrd)
      context.handleHistoryPush("/singleproduct")
    }
    const handleShowSingleProduct2 = (catname2) => {
      let Single2 = [...context.products]
      const SinglePrd2 = Single2.filter(pr => pr.category.split("/")[1] === catname2) 
      context.setSinglePrdCategory2(SinglePrd2)
      context.handleHistoryPush("/singleproduct2")
    }

    for (let i = 0; i < context.Maximum.length; i++) {

        if (context.Maximum[i].slug === slug) {
            max = context.Maximum[i].maximum;
        }
    }
  
    
    let disc = [...context.Discount]
    const Tarhhh = disc.filter(d =>d.DiscountGroup === context.DiscCode)
    
    let num = 0;
    const ClickOnNumbers = (i) => {
        context.setNumber(i)
        setClicked(i)
        num=0
    }

    const handlesabtInSabad = () => {
        if (Role !== "" && context.UseInFo.Role === "") {
            setRoleCheck(true)
        }
        else{
        context.AddBasketFromSimpleProductSlider({num:{num},slug,name,min,max,numSale,numUnit,price,goodsRef,unique_id,unit})
        setDialogSabtInSabad(true)
        }
    }

    const taeedSabt = () => {
        setDialogSabtInSabad(false)
        history.push('./products')
    }

    const deletefromsabad = (slug) => {
        context.handleDeleteItemFromSabad(slug)
        history.push("/Buy")
    }

    return (  
        <React.Fragment>
            <div className="simplePHeader">
                
                <div className="simplesHeader">
                    <div className="barbuttonn">
                        {/* <img src="images/Api.jpg" className="apiLogoHeaders" alt=""/> */}
                    </div>
                    <div className="headersNames">
                        <div className="headerCats1" onClick={()=>handleShowSingleProduct(category.split("/")[0])}>
                            {category.split("/")[0]}
                        </div>
                        <i className="fa fa-chevron-left"></i>
                        <div className="headerCats2" onClick={()=>handleShowSingleProduct2(category.split("/")[1])}>
                            {category.split("/")[1]}
                        </div>
                    </div>
                    <div style={{width:"20%", textAlign:"left"}} onClick={()=>history.go(-1)}>
                        <i className="fa fa-chevron-left" />
                    </div>
                </div>
            </div>


            <div className="SimplePImagePlace">
                {
                    sahmie_bandi === 1?
                    <>
                        <img src={`${config.AndroidProductsPictures}/${slug}.jpg`} alt="" style={{width:"40%", position:"relative", maxWidth:"220px"}}/>
                        <img style={{width:"20%", position:"absolute", right:"5px", top:"60px"}} src={`${config.DiscountImage}/${"sahmiyeh.png"}`} alt=""/>
                    </>
                    :
                    <img src={`${config.AndroidProductsPictures}/${slug}.jpg`} alt="" style={{width:"40%", maxWidth:"220px"}}/>
                }
            </div>
            <div className="SimplePInfoPlace">
                <div className="InfoPlace">
                    <Row className="InfoRows">
                        {name}
                    </Row>
                    {
                        price - Discount_Price <= 10000?
                        <Row className="InfoRows">
                            قیمت محصول : <NumberFormat value={price} displayType={'text'} thousandSeparator={true} /> {" "}ريال{" "}
                        </Row>
                        :
                        <>
                            <Row className="InfoRows">
                            <del style={{color:"red"}}>قیمت محصول : <NumberFormat value={price} displayType={'text'} thousandSeparator={true} /> {" "}ريال{" "}</del>
                            </Row>
                            <Row className="InfoRowsDiscount">
                                قیمت با تخفیف : <NumberFormat value={Discount_Price} displayType={'text'} thousandSeparator={true} /> {" "}ريال{" "}
                            </Row>
                        </>
                    }
                    <Row className="InfoRows">
                        قیمت مصرف کننده : <NumberFormat value={user_price} displayType={'text'} thousandSeparator={true} /> {" "}ريال{" "}
                    </Row>
                    <Row className="lastInfoRows">
                        <Col className="RightCol">
                            {unit}{" "}
                            {numSale} {" "}عددی 
                        </Col>
                        <Col>
                            حداقل خرید: {min} {unit}
                        </Col>
                    </Row>
                </div>
                
                {
                    ULImg !== null?
                        <div className="TarhPlace">
                            <div className="tarhHeader">
                                <Row className="Row1">
                                    <Col className="Colls">
                                        <p> تخفیف {name}</p>
                                    </Col>
                                    <Col className="Colls">
                                        <p>انتخاب شده: {context.number} {unit}</p>
                                    </Col>
                                </Row>
                                {/* <Row className="Row2">
                                    <Button
                                        className="ButtonTarh"
                                    >مشاهده این طرح
                                    </Button>
                                </Row> */}
                            </div>
                            <div className="TarhPlaceMini">
                                {
                                    Tarhhh.map(p=>
                                        <SimpleTarhs
                                        DiscountPercent={p.DiscountPercent}
                                        IMG={p.IMG}
                                        description={p.description}
                                        Title={p.Title}
                                        Az={p.Az}
                                        Ta={p.Ta}
                                        step={p.Step}
                                        />
                                    )
                                }
                                
                            </div>

                        </div>

                    :null
                }
            </div>
            
            <div className="SimplePFooter">
                <div className="row1Footer">
                    {
                    Array.from(Array(max+1), (e, i) => {
                        
                    return  i>0?
                            <li style={{'fontWeight': clicked === i ? 'bold' : 'normal'}} key={i} onClick={() => ClickOnNumbers(i)}>
                                {i} {unit}
                            </li>
                            : null
                        })
                    }
                </div>
                <div className="row2Footer">
                    <Button className="buttonSimple" 
                        onClick={()=>handlesabtInSabad()}
                        >
                        افزودن به سبد خرید
                    </Button>
                </div>
            </div>

            <Modal
            show={DialogSabtInSabad}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                        کالای انتخابی به سبد خرید اضافه شد.
                    </p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>taeedSabt()}>تایید</Button>
                </Modal.Footer>
            </Modal>
            <Modal
            show={DeleteDialog}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                        از حذف کالا مطمئن هستید؟
                    </p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="danger" style={{width:"45%"}} onClick={()=>deletefromsabad(slug)}>بله</Button>
                    <Button variant="success" style={{width:"45%"}} onClick={()=>setDeleteDialog(false)}>خیر</Button>
                </Modal.Footer>
            </Modal>

            <Modal
            show={RoleCheck}
            centered>
                <Modal.Body style={{width:"100%", color:"black"}} className="text-center p-3">
                    <p style={{margin:"0", fontSize:"17px", textAlign:"center"}}>
                    لطفا برای خرید این کالا کد نقش خود را به شماره 09198807264 اعلام نمایید.
                    <br/>
                    </p>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button variant="danger" style={{width:"100%"}} onClick={()=>setRoleCheck(false)}>بستن</Button>
                </Modal.Footer>
            </Modal>
            
        </React.Fragment>
    );
}
 
export default SimplePro;